import React from 'react';
import {getVersion} from '../../services/xpertService';
import {isAnnouncementNew, setAnnouncementConfirmation} from './service';
import {Announcement} from './components/Announcement';
import {getVersionAnnouncements} from './data/announcements';
import {getServerTexts} from './data/texts';

export async function renderAnnouncementDialog(root) {
    const isAutomation = window.location?.search?.toLowerCase().includes('_automation=1');
    if (isAutomation) {
        return;
    }
    const PriorityVersion = getVersion();
    const shouledShowAnnouncement = await isAnnouncementNew(PriorityVersion);
    if (shouledShowAnnouncement) {
        await getServerTexts();
        const announcement = getVersionAnnouncements(PriorityVersion);
        // 'announcement &&' is for situation where there is no announcement but shouldShowAnnouncement is true.
        // isAnnouncementNew returns true when there is no value that match the PriorityVersion.
        // this means that there is no announcement to show but the code can still reach overhear.
        announcement &&
            root.render(
                <Announcement
                    announcements={announcement}
                    onMessageSeen={setAnnouncementConfirmation}
                    announcementVersion={PriorityVersion}
                />
            );
    }
}
